var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('p',{class:`text-h6
  font-weight-bold
  py-2
  px-4
  ${!_vm.isFirst && 'mt-12'}`,staticStyle:{"background-color":"#e3f2fd"}},[_vm._v(" "+_vm._s(_vm.title)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }